import { uploadFile } from '~api/ai/uploadFile';

import {
  FileHandlerCreator,
  FileKey,
  createFileHandler,
} from './FileHandlerConfig';

export const createUploadToS3Handler: FileHandlerCreator<FileKey> =
  createFileHandler(({ onSuccess, onError }) => {
    return async ({ file, onUploadProgress }) => {
      try {
        const fileKey = await uploadFile({
          file,
          onUploadProgress,
        });
        onSuccess({ type: 'fileKey' as const, fileKey, file });
      } catch (error) {
        onError(error);
      }
    };
  });
